import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { CustomerDataPickerComponent } from './customer-data-picker.component';

@NgModule({
  declarations: [
    CustomerDataPickerComponent
  ],
  imports: [
    SharedModule
  ],
  exports:[
    CustomerDataPickerComponent
  ]
})
export class CustomerDataPickerModule { }
